import { Switch } from '@/components/ui/switch'

import { FieldLabel, Hint, Segmented } from '../_shared'
import type { PanelAccent, PanelStyle } from '../config-types'

// The accent is rendered by the panel itself inside Jira; the console names it
// instead of painting a swatch (the console has one accent of its own).
const ACCENTS: { value: PanelAccent; label: string }[] = [
  { value: 'fields', label: 'fields' },
  { value: 'jql', label: 'jql' },
  { value: 'check', label: 'check' },
  { value: 'html', label: 'html' },
  { value: 'neutral', label: 'neutral' },
]

/** Edits config.style — accent, density, show_labels, theme (all stored as data). */
export function StylePanel({
  style,
  onChange,
}: {
  style: PanelStyle
  onChange: (s: PanelStyle) => void
}) {
  return (
    <div className="max-w-[560px] space-y-3.5">
      <div className="flex items-center justify-between gap-3">
        <FieldLabel>Accent</FieldLabel>
        <Segmented
          ariaLabel="accent"
          value={style.accent}
          options={ACCENTS}
          onChange={(accent) => onChange({ ...style, accent })}
        />
      </div>

      <div className="flex items-center justify-between gap-3">
        <FieldLabel>Density</FieldLabel>
        <Segmented
          ariaLabel="density"
          value={style.density}
          options={[
            { value: 'compact', label: 'compact' },
            { value: 'cozy', label: 'cozy' },
          ]}
          onChange={(density) => onChange({ ...style, density })}
        />
      </div>

      <div className="flex items-center justify-between gap-3">
        <FieldLabel>Show labels</FieldLabel>
        <Switch
          checked={style.show_labels}
          onCheckedChange={(show_labels) => onChange({ ...style, show_labels })}
          aria-label="show labels"
        />
      </div>

      <div className="flex items-center justify-between gap-3">
        <FieldLabel>Theme</FieldLabel>
        <Segmented
          ariaLabel="theme"
          value={style.theme}
          options={[
            { value: 'match', label: 'match Jira' },
            { value: 'light', label: 'light' },
            { value: 'dark', label: 'dark' },
          ]}
          onChange={(theme) => onChange({ ...style, theme })}
        />
      </div>

      <Hint>
        Style is stored as data (accent, density, labels, theme) — portable to Forge without a
        rewrite. &quot;match Jira&quot; renders under the viewer instance&apos;s theme.
      </Hint>
    </div>
  )
}
